import React from 'react'
import InfoMessage, { InfoMessageTextLine } from '../InfoMessage'
import { ReactComponent as CommentsIcon } from '@sketch/icons/comments-64'

const CommentTabMessageRestricted: React.FC = () => {
  return (
    <InfoMessage
      title="Comments are restricted"
      icon={<CommentsIcon role="img" />}
    >
      <InfoMessageTextLine>
        You don‘t have permission to view comments in this document.
      </InfoMessageTextLine>
    </InfoMessage>
  )
}

export default CommentTabMessageRestricted
